
<dl
    class="agpr-attributeList"
    [agprLoading]='isLoading'
    [ngClass]="{'agpr-attributeList-grid': isGrid}"
    [attr.id]="id ? id + '.attributeList' : null"

>
    <ng-container
        *ngFor="let attribute of attributes"
    >
        <ng-container
            *ngIf="
                attribute.value !== undefined
                || attribute.type === attributeTypes.adValueUsd
                || attribute.type === attributeTypes.audienceReach
                || (attribute.type === attributeTypes.user && attribute.label === 'createdBy')
            "
        >
            <dt
                *ngIf="attribute.type !== attributeTypes.prominence"
                class="agpr-attributeList-attributeName"
                [ngClass]="{'agpr-attributeList-attributeName--url': attribute.type === attributeTypes?.url}"
                [attr.id]="id ? id + '.attributeList.attributeName.' + attribute.label : null"
            >
                {{ attribute.label | localize }}
                <span
                    *ngIf="attribute.type === attributeTypes.adValueUsd"
                    role="img"
                    class="fa-regular fa-circle-info agpr-attributeList-icon agpr-infoIconStyle"
                    agprTooltip="Mention.details.aveTooltip"
                    tooltipPosition="top"
                >
                </span>
                <span
                    *ngIf="attribute.type === attributeTypes.duration"
                    role="img"
                    class="fa-regular fa-circle-info agpr-attributeList-icon agpr-infoIconStyle"
                    agprTooltip="Mention.details.durationTooltip"
                    tooltipPosition="top"
                >
                </span>
                <span
                    *ngIf="attribute.type === attributeTypes.sentiment"
                    role="img"
                    class="fa-regular fa-circle-info agpr-attributeList-icon agpr-infoIconStyle"
                    agprTooltip="Monitoring.sentiment.tooltip"
                    tooltipPosition="top"
                >
                </span>
                <span
                    *ngIf="attribute.type === attributeTypes.domainAuthority"
                    role="img"
                    class="fa-regular fa-circle-info agpr-attributeList-icon agpr-infoIconStyle"
                    agprTooltip="Mention.details.domainAuthorityTooltip"
                    tooltipPosition="top"
                >
                </span>
                <span
                    *ngIf="attribute.icon"
                    role="img"
                    class="agpr-attributeList-icon"
                    [ngClass]="attribute.icon"
                    [agprTooltip]="attribute?.iconToolTip"
                    tooltipPosition="left"
                >
                </span>
            </dt>
            <ng-container *ngIf="attribute.type === attributeTypes.prominence">
                <dt
                    class="agpr-attributeList-attributeName"
                    [attr.id]="id ? id + '.attributeList.attributeName.' + attribute.label : null"
                >
                    <ng-template
                        [ngTemplateOutlet]="attribute.customTemplate"
                        [ngTemplateOutletContext]="{$implicit: attribute}"
                    ></ng-template>
                </dt>
            </ng-container>
            <dd
                class="agpr-attributeList-attributeValue"
                [attr.id]="id ? id + '.attributeList.attributeValue.' + attribute.label : null"
            >
                <ng-container *ngIf="attribute.type === attributeTypes?.url">
                    <div class="agpr-attributeList-url">
                        <a
                            class="agpr-attributeList-urlString"
                            [href]="attribute.url"
                            target="_blank"
                        >
                            {{ attribute.value | localize }}
                        </a>
                        <button
                            *ngIf="attribute?.showCopyIcon"
                            class="agpr-attributeList-urlCopyIcon fa-kit-duotone fa-agpr-copy"
                            agprTooltip="Reports.sharedReports.rhp.copyUrl"
                            tooltipPosition="top"
                            (click)="copyUrl($event, attribute.url, attribute.message)"
                        ></button>
                    </div>
                </ng-container>
                <!-- TODO: Add tooltips elsewhere as necessary -->
                <ng-container
                    *ngIf="attribute.type === attributeTypes.simple
                    || attribute.type === attributeTypes.prominence">
                    <span
                        [pTooltip]="showFullLengthTooltip ? attribute.value : null"
                        tooltipPosition="top"
                    >
                        {{ attribute.value | localize }}
                    </span>
                </ng-container>
                <ng-container *ngIf="attribute.type === attributeTypes.date">
                    {{ attribute.value
                        | changeTimeZone
                            : (attribute.timezone || preferences?.timeZone)
                            : preferences?.getDateFormatString(true, true, true)
                    }}
                </ng-container>
                <ng-container *ngIf="attribute.type === attributeTypes.utcOffsetDate">
                    {{ attribute.value
                        | changeTimeZone
                            : (attribute.timezone || preferences?.timeZone)
                            : preferences?.getDateFormatString(true, true) + ' z (UTCZ)'
                    }}
                </ng-container>
                @if (attribute.type === attributeTypes.multiDate) {
                    @for (date of attribute.multiDate; track date) {
                        <div>
                            {{ date
                                | changeTimeZone
                                    : (attribute.timezone || preferences?.timeZone)
                                    : preferences?.getDateFormatString(true, true, true)
                            }}
                        </div>
                    }
                }
                <ng-container *ngIf="attribute.type === attributeTypes.user ">
                    <ng-container *ngIf="usersMap[attribute.value]">
                        {{ usersMap[attribute.value] }}
                    </ng-container>
                    <!-- id 1 is a magic value, it means the system saved it -->
                    <ng-container *ngIf="!usersMap[attribute.value] && attribute.value === 1">
                        {{ 'Common.systemProcess' | localize }}
                    </ng-container>
                    <ng-container *ngIf="!usersMap[attribute.value] && attribute.value !== 1">
                        {{ 'Common.unknownUser' | localize }}
                    </ng-container>
                </ng-container>
                <ng-container *ngIf="attribute.type === attributeTypes.simpleList">
                    <span
                        *ngFor="let item of attribute.value"
                        class="agpr-attributeList-attributeValue-simpleList"
                    >
                        {{ item }}
                    </span>
                </ng-container>
                <span
                    *ngIf="attribute.type === attributeTypes.sentiment"
                    class="agpr-attributeList-sentiment"
                >
                    {{ attribute.value | localize }}
                </span>
                <ng-container *ngIf="attribute.type === attributeTypes.adValueUsd">
                    <span *ngIf="attribute.value !== null">
                        {{ attribute.value | CurrencyConversion }}
                    </span>
                    <span *ngIf="attribute.value === null">
                        {{ 'Common.not.available' | localize }}
                    </span>
                </ng-container>
                <ng-container *ngIf="attribute.type === attributeTypes.wordCount">
                    <span *ngIf="attribute.value !== null">
                        {{ attribute.value | number }}
                    </span>
                    <span *ngIf="attribute.value === null">
                        {{ 'Common.not.available' | localize }}
                    </span>
                </ng-container>
                <ng-container *ngIf="attribute.type === attributeTypes.audienceReach">
                    <span class="agpr-attributeList-audienceReach" *ngIf="attribute.value !== null">
                        {{ attribute.value | number }}
                        <a
                            *ngIf="attribute.isSimilarWeb"
                            target="_blank"
                            href="http://www.similarweb.com/"
                            [agprTooltip]="attribute.tooltipHtml"
                            tooltipStyleClass="agpr-similarWeb-tooltip"
                            [useTooltipAsAriaLabel]="false"
                            [attr.aria-label]="'Common.audienceReach.similarWeb' | localize"
                            [escape]="false"
                        >
                            <img
                                class="agpr-attributeList-audienceReach-similarWeb"
                                [src]="appBaseHref + 'assets/images/SimilarWeb-logo.svg'"
                                [alt]="'Common.audienceReach.similarWeb' | localize"
                                width="18"
                                height="18"
                            />
                        </a>
                    </span>
                    <span *ngIf="attribute.value === null">
                        {{ 'Common.not.available' | localize }}
                    </span>
                </ng-container>
                <ng-container *ngIf="attribute.type === attributeTypes.language">
                    <span *ngIf="attribute.value !== null">
                        {{ 'Language.' + attribute.value | localize }}
                    </span>
                    <span *ngIf="attribute.value === null">
                        {{ 'Common.not.available' | localize }}
                    </span>
                </ng-container>
                <ng-container *ngIf="attribute.type === attributeTypes.engagement">
                    <span *ngIf="attribute.value !== null">
                        {{ attribute.value | number }}
                    </span>
                    <span *ngIf="attribute.value === null">
                        {{ 'Common.not.available' | localize }}
                    </span>
                </ng-container>
                <ng-container *ngIf="attribute.type === attributeTypes.duration">
                    <span *ngIf="attribute.value !== null">
                        {{ attribute.value * 1000 | date: 'mm:ss' : 'UTC' }}
                    </span>
                </ng-container>
                <span *ngIf="attribute.type === attributeTypes.number">
                    {{ attribute.value | number }}
                </span>
                <ng-container *ngIf="attribute.type === attributeTypes.customList">
                    <ng-template *ngFor="let value of attribute.value"
                        [ngTemplateOutlet]="attribute.customTemplate"
                        [ngTemplateOutletContext]="{$implicit: value, copyUrl: copyUrl.bind(this), message: attribute.message}"
                    ></ng-template>
                </ng-container>
                <ng-container *ngIf="attribute.type === attributeTypes.domainAuthority">
                    <div
                        class="agpr-attributeList-domainAuthority"
                    >
                        <span> {{ attribute.value | number }} </span>
                        <a
                            target="_blank"
                            href="https://moz.com"
                        >
                            <img
                                class="agpr-attributeList-domainAuthority-mozLogo"
                                [src]="appBaseHref + 'assets/images/moz-logo.svg'"
                                [alt]="'Common.domainAuthority.moz' | localize"
                            />
                        </a>
                    </div>
                </ng-container>
                <ng-container *ngIf="attribute.type === attributeTypes.percent">
                    <span *ngIf="attribute.value !== null">
                        {{ attribute.value | number: '1.0-2' }} {{ '%' }}
                    </span>
                    <span *ngIf="attribute.value === null">
                        {{ 'Common.not.available' | localize }}
                    </span>
                </ng-container>
            </dd>
        </ng-container>
    </ng-container>
</dl>
